var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { InputAFY, ModalAFY, variants, variantsTextField, } from "@affinitysystemsgroup/github-packages-affinity-components/dist";
import React from "react";
import { ModalUiProps } from "../../constanst/adminRolesDTO";
import { FieldContainer, FormContainer, Label, RequiredAsterisk, } from "../../style/styles";
import { useRolForm } from "../../hooks/useRolForm";
export var CreateRoll = function (props) {
    var _a = useRolForm({
        dataFormRoles: props.dataFormRoles,
        setDataFormRoles: props.setDataFormRoles,
        onSubmit: props.onSubmit,
    }), isFormValid = _a.isFormValid, handleInputChange = _a.handleInputChange, handleSubmit = _a.handleSubmit;
    return (_jsx(ModalAFY, __assign({}, ModalUiProps, { title: props.isEdit ? "Editar Rol: " : "Crear Rol", name: props.dataFormRoles.name, openModal: props.openModal, onClose: function () { return props.setOpenModal(false); }, onSave: handleSubmit, buttonAdd: {
            label: "Guardar",
            variant: variants.contained,
            disabled: !isFormValid,
        } }, { children: _jsxs(FormContainer, { children: [_jsxs(FieldContainer, { children: [_jsxs(Label, { children: [_jsx(RequiredAsterisk, { children: "*" }), "Nombre del Rol"] }), _jsx(InputAFY, { variant: variantsTextField.outlined, fullWidth: true, value: props.dataFormRoles.name, onChange: handleInputChange("name"), placeholder: "Ej: Administrador, Fiscalizador, Agente..." })] }), _jsxs(FieldContainer, { children: [_jsxs(Label, { children: [_jsx(RequiredAsterisk, { children: "*" }), "Descripci\u00F3n"] }), _jsx(InputAFY, { variant: variantsTextField.outlined, fullWidth: true, value: props.dataFormRoles.description, onChange: handleInputChange("description"), placeholder: "Describe los permisos y responsabilidades de este rol...", multiline: true, rows: 4 })] })] }) })));
};
